import type { SVGProps } from "react";
export function PlusIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect fill="currentColor" height="9" rx="0.75" width="1.5" x="6.25" y="2.5" />
			<rect fill="currentColor" height="1.5" rx="0.75" width="9" x="2.5" y="6.25" />
		</svg>
	);
}
